import Axios from 'axios'

let endpoint_config = process.env.VUE_APP_ENDPOINT + process.env.VUE_APP_CONFIG_API,
    endpoints = {},
    me = {
        roles: '',
        is_admin: false,
        profile: {
            sub: ''
        }
    },
    api
    // delete link https://designer.mocky.io/manage/delete/a82a2bb0-d19d-4adb-95f3-b097240832d2/o3FrohmnDFEQ07TFmEZuOdSh4WF7eOzSdB3k
    // delete link https://designer.mocky.io/manage/delete/cc9b74fb-d897-4dae-9949-cfab8de0d390/lTaG7LUrYIy5VLXYlrLfPWU35rabrmFvJ1Bv

function parse_endpoint(endpoint, payload){

    Object.keys(payload).forEach((key) => {
        endpoint = endpoint.replace('{' + key + '}', payload[key])
    })
    
    return endpoint
    
    }

export function get_config(token) {
    api = Axios.create({
        headers: {
            'Authorization': 'Bearer ' + token,
            'Content-Type': 'application/json',
            'X-Front-Version': process.env.VUE_APP_FRONT_VERSION,
            post: {},
            get: {}
        }
    })
    //let params = {}
    return api.get(
            endpoint_config,
            //params,
        )
        .then((response) => {
            endpoints = response.data.config.routes
            me = response.data.user
            return response.data;
        }, (error) => {
            window.console.log(error)
            return send_notification(error)
        })
}

export function get_me()
{
    return me
}

export function save_quote(quote) {
    window.console.log('[api.js] - save_quote():')
    window.console.log(quote)
}

////  test chiamate get_requests_admin
export function list_all_requests()
{
    return api.get(
            endpoints.get_requests_all
        )
        .then((response) => {
            return response.data;
        }, (error) => {
            window.console.log('list_all_requests error')
            window.console.log(error)
            return send_notification(error)
        })
}

export function list_all_requests_admin()
{
    return api.get(
            endpoints.get_requests_admin
        )
        .then((response) => {
            return response.data;
        }, (error) => {
            window.console.log('list_all_requests error')
            window.console.log(error)
            return send_notification(error)
        })
}

export function list_my_requests()
{
    return api.get(
        endpoints.get_requests
    )
        .then((response) => {
            return response.data;
        }, (error) => {
            window.console.log('list_my_requests error')
            window.console.log(error)
            return send_notification(error)
        })
}

export function self_assign(payload)
{
    let promise =  api.put(
            endpoints.put_request + '/' + payload.request_id
        )

    promise
        .then(
          () => {},
          (error) => {
              window.console.log('self_assign error')
              window.console.log(error)
              return send_notification(error)
          }
        )

    return promise
}

export function list_all_soldquotes()
{
    return api.get(
            endpoints.get_soldquotes_all
        )
        .then((response) => {
            return response.data;
        }, (error) => {
            window.console.log('list_all_requests error')
            window.console.log(error)
            return send_notification(error)
        })
}

export function list_my_soldquotes()
{
    return api.get(
            endpoints.get_soldquotes
        )
        .then((response) => {
            return response.data;
        }, (error) => {
            window.console.log('list_all_requests error')
            window.console.log(error)
            return send_notification(error)
        })
}

export function self_assign_soldquote(payload)
{
    return api.put(
            endpoints.put_soldquote + '/' + payload.soldquotes_id
        )
        .then((response) => {
            return response.data;
        }, (error) => {
            window.console.log('self_assign error')
            window.console.log(error)
            return send_notification(error)
        })
}

//lmbo973 ::: save assigned soldquote (inutile, rimuovere?)
export function save_soldquote(payload)
{
    return api.post(
        endpoints.soldquotes.save.endpoint+'/'+payload.soldquotes_id, //TODO (inutile, rimuovere?)
        payload
    )
        .then((response) => {
            return response.data;
        }, (error) => {
            window.console.log('api_save_soldquote error')
            window.console.log(error)
            return send_notification(error)
        })
}

export function duplicate_request(payload)
{
    return api.post(
            endpoints.post_request_duplicate + '/' + payload.request_id
        )
        .then((response) => {
            return response.data;
        }, (error) => {
            window.console.log('post_request_duplicate error')
            window.console.log(error)
            return send_notification(error)
        })
}

export function delete_request(payload)
{
    return api.delete(
            parse_endpoint(endpoints.delete_request, payload)
        )
        .then((response) => {
            return response.data;
        }, (error) => {
            window.console.log('delete_request error')
            window.console.log(error)
            return send_notification(error)
        })
}

export function restore_request(payload)
{
    return api.post(
            parse_endpoint(endpoints.post_restore_request, payload)
        )
        .then((response) => {
            return response.data;
        }, (error) => {
            window.console.log('restore_request error')
            window.console.log(error)
            return send_notification(error)
        })
}

export function delete_soldquote(payload)
{
    return api.delete(
            parse_endpoint(endpoints.delete_soldquote, payload)
        )
        .then((response) => {
            return response.data;
        }, (error) => {
            window.console.log('delete_soldquote error')
            window.console.log(error)
            return send_notification(error)
        })
}

export function delete_structure(payload)
{
    return api.delete(
            parse_endpoint(endpoints.delete_struttura, payload)
        )
        .then((response) => {
            return response.data;
        }, (error) => {
            window.console.log('delete_struttura error')
            window.console.log(error)
            return send_notification(error)
        })
}

export function restore_soldquote(payload)
{
    return api.post(
            parse_endpoint(endpoints.post_restore_soldquote, payload)
        )
        .then((response) => {
            return response.data;
        }, (error) => {
            window.console.log('restore_soldquote error')
            window.console.log(error)
            return send_notification(error)
        })
}

export function restore_structure(payload)
{
    return api.post(
            parse_endpoint(endpoints.post_restore_struttura, payload)
        )
        .then((response) => {
            return response.data;
        }, (error) => {
            window.console.log('restore_structure error')
            window.console.log(error)
            return send_notification(error)
        })
}

export function unassign_request(payload)
{
    let promise =  api.put(
        endpoints.put_request_unassign + '/' + payload.request_id
    )

    promise
        .then(
            () => {},
            (error) => {
                window.console.log('self unassign_request error')
                window.console.log(error)
                return send_notification(error)
            }
        )
  return promise
}

export function unassign_soldquote(payload)
{
    let promise = api.put(
        endpoints.put_soldquote_unassign + '/' + payload.soldquotes_id
    )

    promise
        .then(
            () => {},
            (error) => {
                window.console.log('self unassign_soldquote error')
                window.console.log(error)
                return send_notification(error)
            }
        )

  return promise
}

export function get_active_soldquote(payload)
{
    let promise =  api.get(
            endpoints.get_soldquote + '/' + payload.soldquotes_id,
        )

    promise
        .then(
            () => {},
            (error) => {
                window.console.log('get_active_quote error')
                window.console.log(error)
                return send_notification(error)
            }
        )

    return promise
}

export function send_reservations_info(payload)
{
    let promise = api.post(
            endpoints.post_soldquote_notes + '/' + payload.soldquotes_id,
            payload
        )

    promise
        .then(
            () => {},
            (error) => {
                window.console.log('self_assign error')
                window.console.log(error)
                return send_notification(error)
            }
        )

    return promise
}

export function send_booked_notification(payload)
{
    let promise = api.get(
            endpoints.get_soldquote_booked + '/' + payload.soldquotes_id,
        )

    promise
        .then(
            () => {},
            (error) => {
                window.console.log('self_assign error')
                window.console.log(error)
                return send_notification(error)
            }
        )

    return promise
}

export function get_active_quote(payload)
{
    return api.get(
            endpoints.get_request + '/' + payload.request_id,
        )
        .then((response) => {

            // queste guard per la quote appena assegnata che default è {}
            // (e così siamo certi ci sia array services)
            if(!response.data.quote) response.data.quote = {}
            if(!response.data.quote.services) response.data.quote.services = []

            return response.data;


        }, (error) => {
            window.console.log('get_active_quote error')
            window.console.log(error)
            return send_notification(error)
        })
}

export function api_save_quote(payload)
{
    let promise = api.post(
        endpoints.post_quote_save + '/' + payload.request_id,
        payload
    )

    promise
        .then(
            () => {},
            (error) => {
                window.console.log('api_save_quote error')
                window.console.log(error)
                return send_notification(error)
            }
        )


    return promise
}

export function api_validate_quote(payload)
{
  let promise = api.post(
    endpoints.post_quote_validate + '/' + payload.request_id,
    payload
  )

  promise
    .then(
      () => {},
      (error) => {
        window.console.log('api_validate_quote error')
        window.console.log(error)
        return send_notification(error)
      }
    )


  return promise
}

export function api_set_attention_required(payload)
{

  let promise = api.put(
    parse_endpoint(endpoints.put_request_attention_required, payload),
    payload
  )

  promise
    .then(
      () => {},
      (error) => {
        window.console.log('api_set_attention_required error')
        window.console.log(error)
        return send_notification(error)
      }
    )

  return promise
}

// notifications
function send_notification(error)
{
    let callback = function() {
        return window.console.log('Nessuna azione prevista')
    }

    let data = error.response.data
    if(data == ''){
      // errore non gestito lato server (es. PHP FATAL ERROR)
      data = {}
      data.routerPush = 'homepage'
    }
    data.status = (error.response.status)? error.response.status : ''
    data.callback = callback

    window.eventBus.$emit('gotNotification',data)
    return error.response
}

export function test_notification(queryParameters)//test http errors
{
    let promise = api.post(
        endpoints.get_test_notifications+'/'+queryParameters.httpCode,
    )
    // comportamenti da gestire a livello api.js (es. send_notification)
    promise
        .then(
            () => {
                window.console.log('[api.js] - success')
            },
            (error) => {
                window.console.log('[api.js] - error')
                send_notification(error)
            }
        )
    // altri comportamenti da gestire a livello di componente, con callback dedicati ( -> un'altra .then() )
    return promise
}

export function send_quote_for_review(payload)//test http errors
{
    let promise = api.post(
        endpoints.post_quote_review + '/' + payload.request_id,
        payload
    )

    promise
      .then(
            () => {},
            (error) => {
                return send_notification(error)
            }
      )

    return promise
}

export function send_quote_for_publish(payload)//test http errors
{
    let promise = api.post(
        endpoints.post_quote_publish + '/' + payload.request_id,
        payload
    )

    promise
        .then(
            () => {},

            (error) => {
                return send_notification(error)
            }
        )

    return promise
}

export function get_eps_property(payload)
{
    let promise = api.get(
        endpoints.get_eps_property + '/' + payload.eps_property_id,
        //payload
    )

    promise
        .then(
            () => {},
            (error) => {
                return send_notification(error)
            }
        )

    return promise
}

// routes.hub.get_eps_property -> id in get nell'url
// 1058


export function get_requests_paginated(payload)
{
    return api.post(
            endpoints.post_requests_paginated,
            payload
        )
        .then((response) => {
            return response.data;
        }, (error) => {
            window.console.log('get_requests_paginated error')
            window.console.log(error)
            return send_notification(error)
        })
}

export function get_soldquotes_paginated(payload)
{
  return api.post(
    endpoints.post_soldquotes_paginated,
    payload
  )
    .then((response) => {
      return response.data;
    }, (error) => {
      window.console.log('get_soldquotes_paginated error')
      window.console.log(error)
      return send_notification(error)
    })
}

export function get_structures_paginated(payload)
{
  return api.post(
    endpoints.post_structures_paginated,
    payload
  )
    .then((response) => {
      return response.data;
    }, (error) => {
      window.console.log('get_structures_paginated error')
      window.console.log(error)
      return send_notification(error)
    })
}

export function get_struttura(payload)
{
    return api.get(
        parse_endpoint(endpoints.get_struttura, payload)
        )
        .then((response) => {

            return response.data;

        }, (error) => {
            window.console.log('get_struttura error')
            window.console.log(error)
            return send_notification(error)
        })
}

export function post_heartbeat(payload)
{
    let promise = api.post(
        endpoints.post_heartbeat + '/' + payload.request_id,
        payload
    )

    promise
        .then(
            () => {
            },
            (error) => {
                return send_notification(error)
            }
        )

    return promise
}

export function post_heartbeat_soldquotes(payload)
{
  let promise = api.post(
    endpoints.post_heartbeat_soldquotes + '/' + payload.soldquotes_id,
    payload
  )

  promise
    .then(
      () => {},
      (error) => {
        return send_notification(error)
      })

  return promise
}

export function get_messages(payload)
{
    return api.get(
            endpoints.get_messages + '/' + payload.request_id
        )
        .then((response) => {
            return response.data
        }, (error) => {
            window.console.log('get_messages error')
            window.console.log(error)
            return send_notification(error)
        })
}

export function get_history(payload)
{

  let endpoint = (payload.soldquotes_id != undefined && payload.soldquotes_id != '')? endpoints.get_soldquote_history : endpoints.get_request_history

  if(!payload.includi_logs_sistema) payload.includi_logs_sistema = 0 // || 1

  return api.get(
    parse_endpoint(endpoint, payload)
  )
    .then((response) => {
      return response.data
    }, (error) => {
      window.console.log('get_history error')
      window.console.log(error)
      return send_notification(error)
    })
}

export function post_message(payload)
{
    let route = endpoints.post_message + '/' + payload.request_id

    if(payload.is_private) route += '/private'

    return api.post(
            route,
            payload
        )
        .then((response) => {
            return response.data
        }, (error) => {
            window.console.log('post_message error')
            window.console.log(error)
            return send_notification(error)
        })
}

export function post_struttura(payload)
{
    let promise = api.post(
        parse_endpoint(endpoints.post_struttura, payload), payload
        )

        promise
            .then(
                () => {
                },
                (error) => {
                    return send_notification(error)
                }
            )

    return promise
}

export function put_struttura(payload)
{

    let promise = api.put(
        parse_endpoint(endpoints.put_struttura, payload), payload
        )

        promise
            .then(
                () => {
                },
                (error) => {
                    return send_notification(error)
                }
            )

    return promise
}

export function get_strutture_autocomp(payload)
{
    return api.get(
        parse_endpoint(endpoints.get_strutture_autocomplete, payload)
        )
        .then((response) => {

            return response.data;

        }, (error) => {
            window.console.log('get_strutture_autocomplete error')
            window.console.log(error)
            return send_notification(error)
        })
}

export function get_reverse_geocoding(payload)
{
    /*return api.get(
        parse_endpoint(endpoints.get_reverse_geocoding, payload)
        )
        .then((response) => {

            return response.data;

        }, (error) => {
            window.console.log('get_strutture_autocomplete error')
            window.console.log(error)
            return send_notification(error)
        })*/
        let hereApi = Axios.create({
            headers: {
                'Accept': 'application/json',
            }
        })
        //let params = {}
        // TODO: env: process.env.GEOCODE_HEREAPI_API_KEY
        return hereApi.get(
            //'https://geocoder.ls.hereapi.com/6.2/geocode.json?apiKey=pmKP9Xz745ra7L8ObnM_nRCndQffnw_PmFsCSz2eS6I&searchtext=' + payload.q
                //params, //deprecated for alpha-2 country code
                'https://geocode.search.hereapi.com/v1/geocode?apiKey=pmKP9Xz745ra7L8ObnM_nRCndQffnw_PmFsCSz2eS6I&show=countryInfo&q=' + payload.q
            )
            .then((response) => {
                window.console.log(response)
                return response.data.items;
            }, (error) => {
                window.console.log('get_reverse_geocoding error')
                window.console.log(error)
                return send_notification(error)
            })


}

export function delete_image_from_boa(payload)
{
    return api.post(
        endpoints.delete_image_from_boa,
        payload
    )
        .then((response) => {
        return response.data;
        }, (error) => {
        window.console.log('get_soldquotes_paginated error')
        window.console.log(error)
        return send_notification(error)
        })
}

